// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8d4e2cbf","455":"6da2500f","977":"1c2909b0"}[chunkId] + ".chunk.js";
};